import React, { useEffect, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import '../../../../assets/images/codestyle.css';
import ScrollToTop from '../../../Shared/ScrollToTop';
import ShopsImg from '../../../../assets/images/app-image/merchant/shops-list.png';
import ShopsCreateImg from '../../../../assets/images/app-image/merchant/shops-create.png';
import { ProjectTypeContext } from '../../../../ContextHandle';
const Shops = ({ setActivePage, setDocumentation, setDefaultAppActiveMenu }) => {
     /* eslint-disable */
    var projectType = useContext(ProjectTypeContext);
    const projectName = projectType.projectName;
    projectType = projectType.projectType;
    useEffect(() => {
        setActivePage(107);
        setDocumentation(2);
        document.title = "Shops | " + projectName;
        setDefaultAppActiveMenu(6);
    }, [setActivePage, setDocumentation, setDefaultAppActiveMenu, projectName]);

    return (
        <div className='d-flex flex-column justify-content-between doc-page'>
            <ScrollToTop></ScrollToTop>
            <div className='right-content-box-width'>
                <div id="system-requirements" >
                    <h4 className="pt-5 mt-5">Shops Manage</h4>
                    <h4 className="py-3 ">Shops list :</h4>
                    <div >
                        <img src={ShopsImg} className="w-75 rounded" alt="Shops list" />
                    </div>
                    <h4 className="py-3">Shops Create :</h4>
                    <div >
                        <img src={ShopsCreateImg} className="w-75 rounded" alt="Shops create" />
                    </div>

                    <div className="d-flex justify-content-between border-top mt-5">
                        <div className="text-start mt-4">
                            <NavLink to={`/${projectType}/app/merchant/profile`} className="text-decoration-none">
                                <a href='/' className="mb-0 text-decoration-none text-secondary">Previous <i className="bi bi-caret-left" /></a>
                                <h4 className='pagination-title'>Profile</h4>
                            </NavLink>
                        </div>
                        <div className="text-end my-2">
                            <NavLink to={`/${projectType}/app/merchant/parcels`} className="text-decoration-none">
                                <a href="/#" id="quickStartGuide" className="mb-0 text-decoration-none text-secondary">Next <i className="bi bi-caret-right" /></a>
                                <h4 className='pagination-title'>Parcels</h4>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>


        </div>

    );

};

export default Shops;
